<template>
  <b-modal
    id="modal-add-product"
    title="Add Product"
    size="lg"
    title-class="text-black font-18"
    hide-footer
    no-close-on-backdrop
    @close="$emit('close')"
  >
    <div class="row">
      <div class="col-12">
        <b-alert
          v-model="isQtyLargerThanStock"
          variant="danger"
          class="mt-3"
          dismissible
        >Insufficient product stock</b-alert>
        <form @submit.prevent="addProduct"> 
          <div class="form-group">
            <label>Search Product</label>
            <multiselect
              v-model="selectedProduct"
              label="name"
              track-by="name"
              placeholder="Typen Product Name"
              open-direction="bottom"
              :options="availableProducts"
              :multiple="false"
              :internal-search="true"
              :clear-on-select="false"
              :close-on-select="true"
              :hide-selected="false"
              :allowEmpty="false"
              @select="selectProduct"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <strong>{{ option.name }}</strong>
              </template>
            </multiselect>
          </div>
          <div class="form-group">
            <label>Quantity</label>
            <input
              v-model="product.quantity"
              class="form-control"
              type="number"
              step="1"
              min="1"
              required
            />
          </div>
          <div class="form-group">
            <label>Price</label>
            <b-input-group prepend="Rp.">
              <input
                v-model="product.price"
                class="form-control"
                type="text"
                @keyup="formatRupiah"
                required
              />
            </b-input-group>
          </div>
          <button type="submit" class="btn btn-primary">Add Product To Appointment</button>
        </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "PopUpAddProduct",
  components: {
    Multiselect
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    location: {
      type: String,
      required: true
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.$bvModal.show('modal-add-product');
      } else {
        this.$bvModal.hide('modal-add-product')
        this.selectedProduct = null
        this.product = {
          id: null,
          name: null,
          price: null,
          quantity: null,
          status: null
        }
      }
    }
  },
  data() {
    return {
      availableProducts: [],
      selectedProduct: null,
      product: {
        id: null,
        name: null,
        price: null,
        quantity: null,
        status: null
      },
      isQtyLargerThanStock: false
    }
  },
  mounted() {
    this.findProduct()
  },
  methods: {
    formatRupiah() {
      const angka = this.convertToAngka(this.product.price)
      const rupaiah = this.convertToRupiah(angka, false)
      this.product.price = rupaiah
    },
    selectProduct(data){
      this.product = {
        id: data.id,
        name: data.name,
        price: this.convertToRupiah(data.price, false),
        quantity: 1,
        stock: data.stock
      }
    },
    addProduct() {
      // validate quantity
      if (Number(this.product.quantity) > this.product.stock) {
        this.isQtyLargerThanStock = true
        return false
      }
      // add to carts
      this.isQtyLargerThanStock = false
      this.$emit('add', {
        id: this.product.id,
        name: this.product.name,
        price: this.convertToAngka(this.product.price),
        quantity: this.product.quantity,
        stock: this.product.stock
      })
      // Remove a product from the local product picker.
      const indexProduct = this.availableProducts.findIndex(prod => prod.id == this.product.id)
      if (indexProduct >= 0) {
        this.availableProducts.splice(indexProduct, 1)
      }
    },
    addProductToPicker(product) {
      this.availableProducts.push({
        id: product.id,
        name: product.name,
        price: product.price,
        stock: product.stock
      })
    },
    findProduct() {
      this.$axios.get('/product/available').then(response => {
        this.availableProducts = response.data.result.products || []
      }).catch(() => {
        this.availableProducts = []
      })
    }
  }
}
</script>
